import { render, staticRenderFns } from "./TemplateDataAssign.vue?vue&type=template&id=222449b5&scoped=true&"
import script from "./TemplateDataAssign.vue?vue&type=script&lang=js&"
export * from "./TemplateDataAssign.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDataAssign.vue?vue&type=style&index=0&id=222449b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222449b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VDataTable,VForm,VIcon})
